import { FC, useEffect } from "react";
import { Modal } from "@ui/modal";
import { useForbiddenWarning } from "@store/forbidden-warning-store";
import styles from "@scss/modals/forbidden-warning-modal.module.scss";
import { useAuth } from "@store/auth-store";
import { useNavigate } from "react-router-dom";
import { Button } from "@ui/button";

export const ForbiddenWarningModal: FC = () => {
  const { isAuth } = useAuth();
  const [forbiddenWarning, set] = useForbiddenWarning();

  const history = useNavigate();

  const isOpen = forbiddenWarning.message !== null;

  const handleGoBack = () => {
    history(-1);
    set(null);
  };

  useEffect(() => {
    if (!isAuth) {
      set(null);
    }
  }, [isAuth, set]);

  return (
    <Modal open={isOpen} onClose={() => set(null)}>
      <div className={styles.forbiddenWarningModal}>
        <h2 className={styles.forbiddenWarningModal__title}>
          {forbiddenWarning.message?.split("\n").map((item, key) => {
            return (
              <span key={key}>
                {key > 0 ? <b>{item}</b> : <>{item}</>}
                <br />
              </span>
            );
          })}
        </h2>
        <Button
          className={styles.forbiddenWarningModal__btn}
          onClick={handleGoBack}
        >
          Вернуться обратно
        </Button>
      </div>
    </Modal>
  );
};
